import Vue from 'vue'
import Router from 'vue-router'
import CustomerInfo from '@/pages/info/customer-info'
import CustomerReview from '@/pages/info/customer-review'
import ReportList from '@/pages/report/list'
import ReportDetail from '@/pages/report/detail'
import UserProtocol from '@/pages/protocol/user'
import BeParter from '@/pages/parter'
import BeAlliance from '@/pages/alliance'
import KpiFront from '@/pages/kpi-front'
import KpiBack from '@/pages/kpi-back'
import KpiCallLine from '@/pages/kpi-call-line'
import KpiData from '@/pages/kpi-data'
import SipTasks from '@/pages/sip-tasks'
import CreditReport from '@/pages/credit-report'
import MobileIndex from '@/pages/mobile'
import MobileHome from '@/pages/mobile/home'
import MobileKpi from '@/pages/mobile/kpi'
import MobileTasks from '@/pages/mobile/tasks'
import MobileMy from '@/pages/mobile/my'
import NameStatus from '@/pages/name-status'
import CaLogin from '@/pages/ca/login'
import CaHome from '@/pages/ca/index'
import CaProtocol1 from '@/pages/ca/protocol1'
import CaProtocol2 from '@/pages/ca/protocol2'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'CustomerInfo',
    component: CustomerInfo
  }, {
    path: '/customer-review',
    name: 'CustomerReview',
    component: CustomerReview
  }, {
    path: '/report-list',
    name: 'ReportList',
    component: ReportList
  }, {
    path: '/report-detail',
    name: 'ReportDetail',
    component: ReportDetail
  }, {
    path: '/user-protocol',
    name: 'UserProtocol',
    component: UserProtocol
  }, {
    path: '/be-parter',
    name: 'BeParter',
    component: BeParter
  }, {
    path: '/be-alliance',
    name: 'BeAlliance',
    component: BeAlliance
  }, {
    path: '/be-alliance/:inviteCode',
    name: 'BeAlliance',
    component: BeAlliance
  }, {
    path: '/kpi-front',
    name: 'KpiFront',
    component: KpiFront
  }, {
    path: '/kpi-back',
    name: 'KpiBack',
    component: KpiBack
  }, {
    path: '/kpi-call-line',
    name: 'KpiCallLine',
    component: KpiCallLine
  }, {
    path: '/sip-tasks',
    name: 'SipTasks',
    component: SipTasks
  }, {
    path: '/kpi-data',
    name: 'KpiData',
    component: KpiData
  }, {
    path: '/credit-report',
    name: 'CreditReport',
    component: CreditReport
  }, {
    path: '/m',
    name: 'mobile-index',
    component: MobileIndex,
    redirect: '/m/home',
    children: [{
      path: 'home',
      name: 'mobile-home',
      component: MobileHome
    }, {
      path: 'kpi',
      name: 'mobile-kpi',
      component: MobileKpi
    }, {
      path: 'tasks',
      name: 'mobile-tasks',
      component: MobileTasks
    }, {
      path: 'my',
      name: 'mobile-my',
      component: MobileMy
    }]
  }, {
    path: '/name-status',
    name: 'NameStatus',
    component: NameStatus
  }, {
    path: '/ca/login',
    name: 'CaLogin',
    component: CaLogin
  }, {
    path: '/ca/home',
    name: 'CaHome',
    component: CaHome
  }, {
    path: '/ca/protocol1',
    name: 'CaProtocol1',
    component: CaProtocol1
  }, {
    path: '/ca/protocol2',
    name: 'CaProtocol2',
    component: CaProtocol2
  }]
})
